<template>
  <v-card :elevation="client.is_active ? null : 0" :class="client.is_active ? '' : 'not-active'">
    <div class="flex-grow-1 px-2">
      <div class="title-bar d-flex justify-space-between">
        <div>
          <div class="title">
            {{client.name}}
          </div>
          <div class="subtitle">
            {{fullAddress}}
          </div>
        </div>
        <div class="actions">
          <ButtonActionIdentity
            @click="$emit('identity')"
          />
          <ClientCardButtonActions
            :client="client"
            @edit="$emit('edit')"
            @details="$emit('details')"
            @businessUnits="$emit('businessUnits')"
            @certificates="$emit('certificates')"
          />
        </div>
      </div>
      <v-card-text>
        <v-row>
          <div class="user-card-label">
            Davčna št.
          </div>
          <div class="user-card-value">
            {{client.tax_number}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            Kontakt
          </div>
          <div class="user-card-value">
            {{client.contact}}
          </div>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import ClientCardButtonActions from './ClientCardButtonActions'
import ButtonActionIdentity from './ButtonActionIdentity'

export default {
  components: {
    ClientCardButtonActions,
    ButtonActionIdentity
  },
  props: {
    client: {
      required: true,
      type: Object
    }
  },
  computed: {
    cityString () {
      if (this.client.post_code && this.client.city) return `${this.client.post_code}, ${this.client.city}`
      if (this.client.city) return this.client.city
      if (this.client.post_code) return this.client.post_code
      return ''
    },
    fullAddress () {
      return this.client.address + ', ' + this.cityString
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-card {
    padding: 20px;
    &.not-active {
      background-color: #F5F5F5;
      border: 1px solid #EEEEEE;
    }
  }
  .title-bar {
    padding: 10px;
    padding-bottom: 20px;
    box-shadow: 0 4px 3px -5px #455A64;

    .title {
      font-size: 22px;
      font-weight: bold;
      color: #607D8B;
    }
    .subtitle {
      color: #B0BEC5;
      font-size: 12px;
    }
    .actions {
      min-width: 60px;
      max-width: 60px;
      margin-left: 15px;
    }
  }
  .v-card__text {
    .col {
      padding: 6px 12px;
    }
    .user-card-label {
      min-width: 120px;
      color: #BDBDBD;
    }
    .user-card-value {
      color: #607D8B;
      font-weight: bold;
    }
  }
</style>
